import { renderSlot as _renderSlot, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "bs-filters-container__actions" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "m21 21-4.34-4.34" }),
  /*#__PURE__*/_createElementVNode("circle", {
    cx: "11",
    cy: "11",
    r: "8"
  })
], -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M18 6 6 18" }),
  /*#__PURE__*/_createElementVNode("path", { d: "m6 6 12 12" })
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_bs_button = _resolveComponent("bs-button")!

  return (_openBlock(), _createElementBlock("form", {
    class: "bs-filters-container",
    onSubmit: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onSubmit && _ctx.onSubmit(...args)), ["prevent"]))
  }, [
    _createElementVNode("div", {
      class: "bs-filters-container__container",
      style: _normalizeStyle(_ctx.autoColumn ? `grid-template-columns: repeat(${_ctx.itemPerRow}, 1fr)` : undefined)
    }, [
      _renderSlot(_ctx.$slots, "default")
    ], 4),
    _createElementVNode("div", _hoisted_1, [
      (_ctx.$slots['actions'])
        ? _renderSlot(_ctx.$slots, "actions", { key: 0 })
        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _createVNode(_component_bs_button, {
              type: "submit",
              color: "royal-blue",
              loading: _ctx.loading
            }, {
              default: _withCtx(() => [
                _hoisted_2,
                _createTextVNode(" Найти ")
              ]),
              _: 1
            }, 8, ["loading"]),
            _createVNode(_component_bs_button, {
              disbled: _ctx.loading,
              onClick: _ctx.onReset
            }, {
              default: _withCtx(() => [
                _hoisted_3,
                _createTextVNode(" Сброс ")
              ]),
              _: 1
            }, 8, ["disbled", "onClick"])
          ], 64))
    ])
  ], 32))
}